

















































































































































































































































import { Vue, Component } from "vue-property-decorator";
import {
  getActivityListApi,
  delActivityApi,
  getActivitySelectTypeListApi,
  getActivitySelectListApi,
  editActivityStatusApi,
} from "@/api/marketActivity";
import { dateFormat } from "@/utils/timeFormat";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  name: "activityList",
  components: {
    commonDateRangeSelector,
  },
})
export default class extends Vue {
  searchInfo: any = {
    activity_status: -1,
    status: -1,
    is_pay: -1,
  };
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  tableData: any[] = [];
  activityTitleList: any[] = [];
  activityTypeList: any[] = [];
  // 过去时间不可选
  effectiveDate: any = {
    disabledDate(date: any) {
      return date.getTime() > Date.now();
    },
  };
  created() {
    this.getList();
    this.getActivietySelectTypeList();
    this.getActivitySelectList();
  }
  solveSearchInfo(option: any) {
    let params = { ...option };
    if (this.searchInfo.title) {
      params.title = this.searchInfo.title;
    }
    if (this.searchInfo.type) {
      params.type_id = this.searchInfo.type;
    }
    if (this.searchInfo.create_time) {
      params.time_type = 1;
      params.start_time =
        new Date(this.searchInfo.create_time[0] + " 00:00:01").getTime() / 1000;
      params.end_time =
        new Date(this.searchInfo.create_time[1] + " 23:59:59").getTime() / 1000;
    }
    if (this.searchInfo.effective_roster_start_num) {
      if (String(this.searchInfo.effective_roster_start_num).includes(".")) {
        this.$message({
          message: "活动名单数必须为整数",
          type: "error",
        });
        return false;
      }
      if (this.searchInfo.effective_roster_start_num < 0) {
        this.$message({
          message: "活动名单数必须大于或等于0",
          type: "error",
        });
        return false;
      }
      params.effective_roster_start_num = Number(
        this.searchInfo.effective_roster_start_num
      );
    }
    if (this.searchInfo.effective_roster_end_num) {
      if (String(this.searchInfo.effective_roster_start_num).includes(".")) {
        this.$message({
          message: "活动名单数必须为整数",
          type: "error",
        });
        return false;
      }
      if (this.searchInfo.effective_roster_end_num < 0) {
        this.$message({
          message: "活动名单数必须大于或等于0",
          type: "error",
        });
        return false;
      }
      params.effective_roster_end_num = Number(
        this.searchInfo.effective_roster_end_num
      );
    }
    if (this.searchInfo.activity_status > 0) {
      params.activity_status = Number(this.searchInfo.activity_status);
    }
    if (this.searchInfo.status > 0) {
      params.status = Number(this.searchInfo.status);
    }
    if (this.searchInfo.is_pay > 0) {
      params.is_pay = Number(this.searchInfo.is_pay);
    }
    return params;
  }
  getList(params?: any) {
    let option = this.solveSearchInfo(params);
    getActivityListApi(option).then((res: any) => {
      if (res.error_code === 0) {
        res.data.list.forEach((item: any) => {
          item.create_time = item.create_time
            ? dateFormat("YYYY-mm-dd HH:MM:SS", item.create_time * 1000)
            : "-";
          item.start_time = item.start_time
            ? dateFormat("YYYY-mm-dd HH:MM:SS", item.start_time * 1000)
            : "-";
          item.end_time = item.end_time
            ? dateFormat("YYYY-mm-dd HH:MM:SS", item.end_time * 1000)
            : "-";
          item.paid_amount = item.paid_amount === "" ? "-" : item.paid_amount;
          // item.status = item.activity_status === 3 ? 2 : item.status;
          item.status = item.status === 1 ? true : false;
        });
        this.tableData = res.data.list;
        this.total = res.data.total;
      } else {
        this.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  handleSearch(v: any) {
    if (v === "effective_roster_start_num") {
      if (
        this.searchInfo.effective_roster_start_num &&
        this.searchInfo.effective_roster_end_num &&
        Number(this.searchInfo.effective_roster_start_num) >
          Number(this.searchInfo.effective_roster_end_num)
      ) {
        return this.$message({
          message: "最低数量不能大于最高数量",
          type: "error",
        });
      }
    }
    if (v === "effective_roster_end_num") {
      if (
        this.searchInfo.effective_roster_start_num &&
        this.searchInfo.effective_roster_end_num &&
        Number(this.searchInfo.effective_roster_start_num) >
          Number(this.searchInfo.effective_roster_end_num)
      ) {
        return this.$message({
          message: "最低数量不能大于最高数量",
          type: "error",
        });
      }
    }
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
  }
  // 新增
  handleAdd() {
    this.$router.push({
      name: "addActivity",
    });
  }
  // 编辑
  handleEdit(scope: any) {
    this.$router.push({
      name: "addActivity",
      query: {
        activity_id: scope.row.activity_id,
      },
    });
  }
  // 删除
  handleDel(scope: any) {
    this.$confirm("确定对该活动进行删除吗？", `"删除-${scope.row.title}"`, {
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      confirmButtonClass: "mwow-button-filled success",
      cancelButtonClass: "mwow-button-filled",
      iconClass: "mwow-icon-error",
    })
      .then(() => {
        if (scope.row.status || scope.row.activity_status !== 3) {
          this.$message({
            // message: "活动未下架无法进行删除操作",
            message: "活动结束且下架才能进行删除操作",
            type: "error",
          });
        } else {
          delActivityApi({ activity_id: scope.row.activity_id }).then(
            (res: any) => {
              if (res.error_code === 0) {
                this.$message({
                  message: "删除成功",
                  type: "success",
                });
                this.getList();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            }
          );
        }
      })
      .catch(() => {});
  }
  // 活动名称列表
  getActivitySelectList(v?: any) {
    getActivitySelectListApi({
      page: 1,
      page_size: 100,
      title: v,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.activityTitleList = res.data.list;
      }
    });
  }
  // 活动类型列表
  getActivietySelectTypeList(v?: any) {
    getActivitySelectTypeListApi({
      page: 1,
      page_size: 100,
      title: v,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.activityTypeList = res.data.list;
      }
    });
  }
  handlePagerChange(e: number) {
    this.page = e;
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
  // 跳转推广码页面
  toPromotionCode(scope: any) {
    this.$router.push({
      name: "promotionCode",
      query: {
        activity_id: scope.row.activity_id,
      },
    });
  }
  // 跳转意向名单页面
  toViewList(scope: any) {
    this.$router.push({
      name: "viewList",
      query: {
        activity_id: scope.row.activity_id,
        is_pay: scope.row.is_pay,
      },
    });
  }
  // 模糊搜索 - 活动名称
  handleSearchTitle(v: any) {
    this.getActivitySelectList(v);
  }
  // 模糊搜索 - 活动类型
  handleSearchType(v: any) {
    this.getActivietySelectTypeList(v);
  }
  // 列表下拉
  handleVisible(v: any) {
    if (v) {
      this.getActivietySelectTypeList();
      this.getActivitySelectList();
    }
  }
  handleActivityStatus(scope: any) {
    if (scope.row.activity_status === 1) {
      return "未开始";
    }
    if (scope.row.activity_status === 2) {
      return "进行中";
    }
    if (scope.row.activity_status === 3) {
      return "已结束";
    }
  }
  handleChangeStatus(scope: any) {
    let status = scope.row.status === true ? 1 : 2;
    editActivityStatusApi({
      activity_id: scope.row.activity_id,
      status: status,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.$message({
          type: "success",
          message: "操作成功",
        });
      }
    });
  }
  handleInput(params: any, evt: any) {
    // 限制数量
    if (evt.length > 9) {
      if (params === "effective_roster_start_num") {
        this.searchInfo.effective_roster_start_num = Number(evt.slice(0, 9));
      }
      if (params === "effective_roster_end_num") {
        this.searchInfo.effective_roster_end_num = Number(evt.slice(0, 9));
      }
    }
  }
}
